import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { territoryService } from "../services/territory.api";
import { setTerritoryItems } from "store/territorySlice";
import { selectTerritoryItems } from "store/territorySlice";

const useTerritory = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const territoryList = useSelector(selectTerritoryItems);

  const getTerritoryList = async (data) => {
    setLoading(true);
    try {
      const response = await territoryService.fetchList(data);
      if (response.success) {
        dispatch(setTerritoryItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const createTerritory = async (payload) => {
    setLoading(true);
    try {
      const response = await territoryService.createTerritory(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const updateTerritory = async (id, payload) => {
    setLoading(true);
    try {
      const response = await territoryService.updateTerritory(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const deleteTerritory = async (id) => {
    setLoading(true);
    try {
      const response = await territoryService.deleteTerritory(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const getTerritoryById = async (id) => {
    setLoading(true);
    try {
      const response = await territoryService.fetchTerritoryById(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const getTerritoryOptions = async () => {
    setLoading(true);
    try {
      const response = await territoryService.getTerritoryOptions();
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const assignSalesRep = async (id, payload) => {
    setLoading(true);
    try {
      const response = await territoryService.assignSalesRep(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  return {
    getTerritoryOptions,
    getTerritoryList,
    territoryList,
    createTerritory,
    getTerritoryById,
    deleteTerritory,
    updateTerritory,
    assignSalesRep,
    loading,
    error,
  };
};

export default useTerritory;
